module.exports = __webpack_public_path__ + "img/Gifcard_pacchetto_B.f7cf2c32.jpg";